import { ArrowsClockwise } from "@phosphor-icons/react";

import ProfileImage from "common/components/ui/ProfileImage";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

export default function SyncingBadge({ accountIds }: { accountIds: string[] }) {
  const { accounts } = useSelectedWorkspaceContext();
  const filteredAccounts = accounts.filter(({ id }) => accountIds.includes(id));

  return (
    <Tooltip>
      <TooltipTrigger className="rounded-full bg-purple-600 p-0.5">
        <ArrowsClockwise
          size={14}
          className="animate-spin fill-white"
          weight="bold"
        />
      </TooltipTrigger>
      <TooltipContent align="start" className="flex flex-col gap-y-1.5">
        <p>
          Your leads are currently synchronizing with LinkedIn, for the
          following accounts:
        </p>
        {filteredAccounts.map(({ id, full_name, picture_url }) => (
          <div key={id} className="flex items-center gap-x-1">
            <ProfileImage src={picture_url} size="3xs" />
            <span className="text-button-xxs">{full_name}</span>
          </div>
        ))}
      </TooltipContent>
    </Tooltip>
  );
}
